import React from 'react'

type Props = {
    className?  : string
    style?      : any

    size        : '26' | '22'
    option      : Option

    onClick?    : func
    onDelete?   : func
}

export default function SelectMultiGenericOptionPill(props: Props) {
    if (!props.option) return null

    const onClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()
        if(props.onClick) props.onClick(props.option)
    }

    const onDelete = (e: React.SyntheticEvent) => {
        e.stopPropagation()
        if(props.onDelete) props.onDelete(props.option)
    }

    const optionColor = _.get(props.option, 'color', null) //!_.isNil(option.color) ? option.color : null;

    const pillClasses = Classes("ui5-pillbox", "s{0}".f(props.size), "m-t-4", "m-b-4", props.className, {
        'default-color'                     : !optionColor,
        ['gd-c-bgp-'+optionColor]           : !!optionColor,
        ['gd-c-pale-border-'+optionColor]   : !!optionColor
    })

    return (
        <div className={pillClasses} style={props.style} onClick={!!props.onClick ? onClick : undefined}>
            {props.option.label}
            {props.onDelete && <div className="delete-button centered ui5-ico-delete s14 gray" onClick={onDelete}/>}
        </div>
    );
}

SelectMultiGenericOptionPill.defaultProps = {
    size        : '26'
}